import ChartPDFParametersFormattingStrategy from './ChartPDFParametersFormattingStrategy'
import ChartPDFSingleDateFormattingStrategy from './ChartPDFSingleDateFormattingStrategy'

export default class ChartPDFBalanceParametersFormattingStrategy extends ChartPDFParametersFormattingStrategy {
    init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
        super.init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor)
        return this
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFSingleDateFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters) {
        return {
            firstRow: this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
            secondRow: ' '
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFBalanceParametersFormattingStrategy.js